import { ProjectCreatorEntitySidenavComponent } from './../modules/project-creator-entity-sidenav/components/project-creator-entity-sidenav/project-creator-entity-sidenav.component';
import { Injector } from '@angular/core';
import { WindowHelper } from '@shared/helpers/window.helper';
import { AppInjector } from '@shared/services/app-injector.service';
import { SidenavService } from '@shared/services/sidenav/sidenav.service';

export class ProjectCreatorEntitySidenavController {
  injector: Injector;
  sidenav: SidenavService;

  config: any = {
    maxWidth: '709px',
    class: 'no-padding',
    hideBackdrop: WindowHelper.isMoreLessMD,
    hardReload: true,
    closeOnBackdrop: true,
  };

  constructor() {
    this.injector = AppInjector.getInjector();
    this.sidenav = this.injector.get(SidenavService);
  }

  createProjectEntity(_params?: any) {
    const params = Object.assign({ viewState: 'create' }, _params);
    this.sidenav.open(ProjectCreatorEntitySidenavComponent, this.config, params);
  }

  editProjectEntity(_params?: any) {
    const params = Object.assign({ viewState: 'edit' }, _params);
    this.sidenav.open(ProjectCreatorEntitySidenavComponent, this.config, params);
  }
}
